import OverallReportCard from "../../../../components/AdminCards/OverallReportCard";
import { languageHelper } from "../../../../config/helperFunctions";



const OverAllCounter = () => {
  const counterData = [
    {
      path: (
        <path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
      ),
      count: "100",
      title: languageHelper("TOTAL SALE") || "TOTAL SALE",
      titletwo: languageHelper("VAT") || "VAT",
    },
    {
      path: (
        <path d="M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
      ),
      count: "0",
      title: languageHelper("TOTAL PURCHASE") || "TOTAL PURCHASE",
      titletwo: languageHelper("VAT") || "VAT",
    },

    {
      path: (
        <path d="M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
      ),
      count: "0",
      title: languageHelper("TOTAL EXPENSE") || "TOTAL EXPENSE",

      titletwo: languageHelper("VAT") || "VAT",
    },
    {
      path: (
        <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z" />
      ),
      count: "0",
      title: languageHelper("TOTAL RETURN") || "TOTAL RETURN",

      titletwo: languageHelper("VAT") || "VAT",
    },
  ]

  return (
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-8 border-0">
        <div className="flex  flex-wrap gap-8 place-items-center md:py-2">
          {counterData &&
            counterData.map((data) => (
              <OverallReportCard data={data} />
            ))}
        </div>

        <div className="flex justify-center pt-10">
          <div className=" border border-d-bg rounded-md  ">
            <div className="p-4">
              <h2 className="text-xl font-bold ">
                VAT FORMULA : TOTAL VAT = TOTAL SALE VAT - (PURCHASE VAT +
                RETURN VAT + EXPENSE VAT)
              </h2>
            </div>
          </div>
        </div>
      </div>
  );
};

export default OverAllCounter;
